import React from 'react';
import { Button, FormHelp, Text } from '@zillow/constellation';

const ArchiveProperty = ({
    abortArchiveProcess,
    actionHandler,
    address,
    errorAtArchive,
    isArchived,
}) => {
    const displayText = !isArchived ? `${address} will move to your archived properties.`
        : `${address} will move to your for rent and off market properties.`;

    const errorText = !isArchived ? 'There was an error while archiving. Please try again.'
        : 'There was an error while unarchiving. Please try again.';

    const buttonText = !isArchived ? 'Yes, Archive Property' : 'Yes, Unarchive Property';
    return (
        <div>
            <Text
                paddingBottom="xs"
                fontType="sectionheading"
                as="div"
            >
                {isArchived ? 'Unarchive property' : 'Archive property'}
            </Text>
            <Text
                paddingY="xs"
                as="div"
            >
                {displayText}
            </Text>
            <Button
                marginY="xs"
                fluid={true}
                buttonType="primary"
                onClick={actionHandler}
            >
                {buttonText}
            </Button>
            <Button
                marginY="xs"
                fluid={true}
                buttonType="secondary"
                onClick={abortArchiveProcess}
            >
                Cancel
            </Button>
            {errorAtArchive && (
                <FormHelp error={errorAtArchive}>
                    {errorText}
                </FormHelp>
            )}
        </div>
    );
};

export default ArchiveProperty;
